import { useMutation } from '@tanstack/react-query';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import useApi from '../../api/backendApiContext';
import { useNotification } from '../../notification/notificationsContext';
import { Customer } from '../types';
import { analyticsTrack } from '../../web-analytics/webAnalytics';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';

export const useRevertCancellationMutation = () => {
  const queryCacheManager = useQueryCacheManager();
  const { billingApi } = useApi();
  const { notifySuccess, notifyError } = useNotification();

  return useMutation<Customer, unknown, void>(async () => billingApi.revertCancellation(), {
    // eslint-disable-next-line no-unused-vars,@typescript-eslint/no-unused-vars
    onSuccess: async (customer: Customer) => {
      await queryCacheManager.invalidateBillingCustomer();
      await queryCacheManager.invalidateInvoices();
      notifySuccess({
        notificationMsg: 'Your plan has been resumed.',
      });

      analyticsTrack(AnalyticsEvent.BILLING_PLAN_RESUMED);
    },
    onError: async () => {
      await queryCacheManager.invalidateBillingCustomer();
      await queryCacheManager.invalidateInvoices();

      notifyError({
        notificationMsg: 'Failed to resume plan. Please try again or contact support.',
      });
    },
  });
};
